// extracted by mini-css-extract-plugin
export default {"wrapper":"informationItem_wrapper__3hJE6"};